;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
import { cn } from "@/lib/utils"

/**
 * Replicates the old styled MUI Button: 42px yellow pill
 * (#E6FF63 -> #c2d753 pressed hover), roboto, uppercase button type.
 */
const BUTTON_CLASSES =
  "ml-[6px] inline-flex h-[42px] min-w-16 cursor-pointer items-center justify-center rounded-[100px] border-0 bg-[#E6FF63] px-[15px] font-roboto text-[0.875rem] leading-[1.75] font-medium tracking-[0.02857em] uppercase whitespace-nowrap text-[#092C3C] no-underline transition-colors duration-250 hover:bg-[#c2d753]"

type SignUpButtonProps = React.ComponentProps<"button"> & {
  href?: string
  children?: React.ReactNode
}

export default function SignUpButton({
  href,
  children,
  className,
  ...props
}: SignUpButtonProps) {
  if (href) {
    return (
      <Link href={href} className={cn(BUTTON_CLASSES, className)}>
        {children}
      </Link>
    )
  }

  return (
    <button type="button" className={cn(BUTTON_CLASSES, className)} {...props}>
      {children}
    </button>
  )
}
